@if(loading == true) {
  <div class="overlay">
    <mat-spinner [diameter]="60" color="primary"></mat-spinner>
  </div>
}
@else {
    <div class="page-wrapper">
      <app-header></app-header>
        <main class="main-content">
          <div class="job-openings-container">
            <h1 class="page-title">Current Job Openings</h1>
            <hr class="divider" />
            <p class="job-intro">
              From our roots as an asset originator, Spruce has emerged as a leading owner and operator of a portfolio of distributed generation
              solar and residential energy assets in the U.S. Our asset management capabilities extend over 330 MW of installed capacity, and our goal
              is to acquire operating residential and C&I solar assets and PPAs in North America.
            </p>

            <div class="jobs-section">
              <h2 class="section-title">General</h2>
              <hr class="divider" />
              <div class="job-grid">
                <div *ngFor="let job of jobDetails" class="job-card">
                  <h3 class="job-title">{{ job.title }}</h3>
                  <p class="job-location">
                    <strong>Location:</strong> {{ job.city }}, {{ job.state }}
                  </p>
                  <button *ngIf="job.id"
                          class="job-button"
                          (click)="viewDetails(job.id)">
                    View Details →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
      <app-footer></app-footer>
    </div>
  }
